import { getI18n } from 'react-i18next';

export const VALIDATION_USER_RACF_ALREADY_IN_USE = 'validation.user.racfAlreadyInUse';
export const VALIDATION_USER_EMPTY_RACF = 'validation.user.emptyRacf';
export const VALIDATION_USER_NOT_EMPTY_RACF = 'validation.user.notEmptyRacf';
export const VALIDATION_USER_INVALID_RACF_LENGTH = 'validation.user.invalidRacfLength';
export const VALIDATION_USER_INVALID_RACF = 'validation.user.invalidRacf';
export const VALIDATION_USER_INVALID_CODE_LENGTH = 'validation.user.invalidCodeLength';
export const VALIDATION_USER_INVALID_CODE = 'validation.user.invalidCode';
export const VALIDATION_USER_EMPTY_NAME = 'validation.user.emptyName';
export const VALIDATION_USER_NOT_EMPTY_NAME = 'validation.user.notEmptyName';
export const VALIDATION_USER_INVALID_NAME_LENGTH = 'validation.user.invalidNameLength';
export const VALIDATION_USER_EMPTY_EMAIL = 'validation.user.emptyEmail';
export const VALIDATION_USER_NOT_EMPTY_EMAIL = 'validation.user.notEmptyEmail';
export const VALIDATION_USER_INVALID_EMAIL_LENGTH = 'validation.user.invalidEmailLength';
export const VALIDATION_USER_INVALID_EMAIL = 'validation.user.invalidEmail';
export const VALIDATION_USER_INVALID_PHONE_LENGTH = 'validation.user.invalidPhoneLength';
export const VALIDATION_USER_INVALID_PHONE = 'validation.user.invalidPhone';
export const VALIDATION_USER_NOT_EMPTY_PHONE = 'validation.user.notEmptyPhone';
export const VALIDATION_USER_INVALID_ADDRESS_LENGTH = 'validation.user.invalidAddressLength';
export const VALIDATION_USER_NOT_EMPTY_ADDRESS = 'validation.user.notEmptyAddress';
export const VALIDATION_USER_BID_AS_BROKER_SHOULD_BE_BIDDER = 'validation.user.bidAsBrokerShouldBeBidder';
export const VALIDATION_USER_INVALID_ROLES = 'validation.user.badRoles';
export const VALIDATION_USER_NOT_NULL_ROLES = 'validation.user.notNullRoles';
export const VALIDATION_USER_CODE_ALREADY_IN_USE_IN_MEMBER = 'validation.user.userCodeAlreadyInUseInMember';
export const VALIDATION_USER_NULL_ASSIGNED_ZONES = 'validation.user.nullAssignedZones';
export const VALIDATION_USER_NOT_NULL_ASSIGNED_ZONES = 'validation.user.notNullAssignedZones';
export const VALIDATION_USER_NOT_NULL_USER_CODE = 'validation.user.notNullUserCode';
export const VALIDATION_USER_EMPTY_USER_CODE = 'validation.user.emptyUserCode';
export const VALIDATION_USER_INVALID_ASSIGNED_ZONE = 'validation.user.invalidAssignedZone';
export const VALIDATION_USER_EMPTY_ASSIGNED_ZONE = 'validation.user.emptyAssignedZone';
export const VALIDATION_USER_NULL_MEMBER_IDS = 'validation.user.nullMemberIds';
export const VALIDATION_USER_NOT_NULL_MEMBER_IDS = 'validation.user.notNullMemberIds';
export const VALIDATION_USER_INTERNAL_USER_CREATION = 'validation.user.internalUserCreation';
export const VALIDATION_USER_IMMUTABLE_RACF = 'validation.user.immutableRacf';
export const VALIDATION_USER_IMMUTABLE_USER_CODE = 'validation.user.immutableUserCode';
export const VALIDATION_USER_NOT_BIDDING_USER = 'validation.user.notBiddingUser';
export const ERROR_USER_NOT_FOUND = 'user.notFound';
export const ERROR_USER_INVALID_OPERATION_ON_INTERNAL_USER = 'user.invalidOperationOnInternalUser';
export const ERROR_USER_INVALID_SORT_KEY = 'user.sort.invalidField';
export const ERROR_USER_NOT_ASSIGNED_TO_MEMBER = 'validation.bid.userIsNotAssignedToMember'; // should be removed once backend knows how to pass params to 'validation.userHasNotThisMember' (i.e. ERROR_USER_DOES_NOT_HAVE_MEMBER will be used on frontend instead)
export const ERROR_USER_DOES_NOT_HAVE_MEMBER = 'validation.userHasNotThisMember';
export const ERROR_USER_INVALID_ROLE_ASSIGNED = 'validation.user.invalidRoleAssigned';
export const ERROR_USER_TOTP_GENERATION = 'user.totpGeneration';

export const createUserErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case ERROR_USER_NOT_ASSIGNED_TO_MEMBER:
            result = i18n.t(`auctions.bids-list.place-bid.error.user-not-assigned-to-member${params.recordNumber ? '-with-record-number' : ''}`, params);
            break;
        case ERROR_USER_DOES_NOT_HAVE_MEMBER:
            result = i18n.t('auctions.bids-list.place-bid.error.user-does-not-have-member', { user: params[0], member: params[1] });
            break;
        case VALIDATION_USER_RACF_ALREADY_IN_USE:
            result = i18n.t('users.error.user-racf-already-in-use');
            break;
        case VALIDATION_USER_EMPTY_RACF:
            result = i18n.t('users.error.user-racf-empty');
            break;
        case VALIDATION_USER_NOT_EMPTY_RACF:
            result = i18n.t('users.error.user-racf-not-empty');
            break;
        case VALIDATION_USER_INVALID_RACF_LENGTH:
            result = i18n.t('users.error.user-racf-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_USER_INVALID_RACF:
            result = i18n.t('users.error.user-racf-invalid');
            break;
        case VALIDATION_USER_INVALID_CODE_LENGTH:
            result = i18n.t('users.error.user-code-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_USER_INVALID_CODE:
            result = i18n.t('users.error.user-code-invalid');
            break;
        case VALIDATION_USER_EMPTY_NAME:
            result = i18n.t('users.error.user-name-empty');
            break;
        case VALIDATION_USER_NOT_EMPTY_NAME:
            result = i18n.t('users.error.user-not-empty-name');
            break;
        case VALIDATION_USER_INVALID_NAME_LENGTH:
            result = i18n.t('users.error.user-name-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_USER_EMPTY_EMAIL:
            result = i18n.t('users.error.user-email-empty');
            break;
        case VALIDATION_USER_NOT_EMPTY_EMAIL:
            result = i18n.t('users.error.user-not-empty-email');
            break;
        case VALIDATION_USER_INVALID_EMAIL_LENGTH:
            result = i18n.t('users.error.user-email-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_USER_INVALID_EMAIL:
            result = i18n.t('users.error.user-email-invalid');
            break;
        case VALIDATION_USER_INVALID_PHONE_LENGTH:
            result = i18n.t('users.error.user-phone-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_USER_INVALID_PHONE:
            result = i18n.t('users.error.user-phone-invalid');
            break;
        case VALIDATION_USER_NOT_EMPTY_PHONE:
            result = i18n.t('users.error.user-not-empty-phone');
            break;
        case VALIDATION_USER_INVALID_ADDRESS_LENGTH:
            result = i18n.t('users.error.user-address-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_USER_NOT_EMPTY_ADDRESS:
            result = i18n.t('users.error.user-not-empty-address');
            break;
        case VALIDATION_USER_BID_AS_BROKER_SHOULD_BE_BIDDER:
            result = i18n.t('users.error.broker-should-be-bidder');
            break;
        case VALIDATION_USER_INVALID_ROLES:
            result = i18n.t('users.error.user-roles-invalid');
            break;
        case VALIDATION_USER_NOT_NULL_ROLES:
            result = i18n.t('users.error.user-roles-not-null');
            break;
        case VALIDATION_USER_CODE_ALREADY_IN_USE_IN_MEMBER:
            result = i18n.t('users.error.user-code-already-in-use-in-member');
            break;
        case VALIDATION_USER_NULL_ASSIGNED_ZONES:
            result = i18n.t('users.error.user-assigned-zones-null');
            break;
        case VALIDATION_USER_NOT_NULL_ASSIGNED_ZONES:
            result = i18n.t('users.error.user-assigned-zones-not-null');
            break;
        case VALIDATION_USER_NOT_NULL_USER_CODE:
            result = i18n.t('users.error.user-code-not-null');
            break;
        case VALIDATION_USER_EMPTY_USER_CODE:
            result = i18n.t('users.error.user-code-empty');
            break;
        case VALIDATION_USER_INVALID_ASSIGNED_ZONE:
            result = i18n.t('users.error.user-assigned-zone-invalid');
            break;
        case VALIDATION_USER_EMPTY_ASSIGNED_ZONE:
            result = i18n.t('users.error.user-assigned-zone-empty');
            break;
        case VALIDATION_USER_NULL_MEMBER_IDS:
            result = i18n.t('users.error.user-member-ids-null');
            break;
        case VALIDATION_USER_NOT_NULL_MEMBER_IDS:
            result = i18n.t('users.error.user-member-ids-not-null');
            break;
        case VALIDATION_USER_INTERNAL_USER_CREATION:
            result = i18n.t('users.error.user-racf-internal-user');
            break;
        case VALIDATION_USER_IMMUTABLE_RACF:
            result = i18n.t('users.error.user-immutable-racf');
            break;
        case VALIDATION_USER_IMMUTABLE_USER_CODE:
            result = i18n.t('users.error.user-immutable-user-code');
            break;
        case VALIDATION_USER_NOT_BIDDING_USER:
            result = i18n.t('users.error.user-not-bidding-user');
            break;
        case ERROR_USER_NOT_FOUND:
            result = i18n.t('users.error.user-not-found');
            break;
        case ERROR_USER_INVALID_OPERATION_ON_INTERNAL_USER:
            result = i18n.t('users.error.user-invalid-operation-on-internal-user');
            break;
        case ERROR_USER_INVALID_SORT_KEY:
            result = i18n.t('users.error.user-invalid-sort-key', { sortKey: params[0] });
            break;
        case ERROR_USER_INVALID_ROLE_ASSIGNED:
            result = i18n.t('users.error.user-invalid-role-assigned');
            break;
        case ERROR_USER_TOTP_GENERATION:
            result = i18n.t('users.error.totp-generation');
            break;
        default:
            result = undefined;
    }
    return result;
};
